import { CstParser } from 'chevrotain';
import {
    AdditionOperator,
    allTokens,
    IsToken,
    LParen,
    Minus,
    MultiplicationOperator,
    NumberLiteral,
    OfExpression,
    OfToken,
    PercentLiteral,
    PowerOperator,
    RParen
} from 'math/lexer';

const defineRules = $ => {
    $.RULE('expression', () => {
        $.OR([
            {
                GATE: () => {
                    const nextIsTokType = $.LA(2).tokenType;
                    const nextTokPercentLiteral = $.LA(3).tokenType;
                    const nextOfTokType = $.LA(4).tokenType;
                    return (
                        nextIsTokType === IsToken &&
                        nextTokPercentLiteral === PercentLiteral &&
                        nextOfTokType === OfToken
                    );
                },
                ALT: () => $.SUBRULE($.whatNumberOfPercentExpression)
            },
            {
                GATE: () => {
                    const nextTokType = $.LA(2).tokenType;
                    return nextTokType === OfToken;
                },
                ALT: () => $.SUBRULE($.percentOfExpression)
            },
            { ALT: () => $.SUBRULE($.additionExpression) }
        ]);
    });

    //  lowest precedence thus it is first in the rule chain
    // The precedence of binary expressions is determined by how far down the Parse Tree
    // The binary expression appears.
    $.RULE('additionExpression', () => {
        $.SUBRULE($.multiplicationExpression, { LABEL: 'lhs' });
        $.MANY(() => {
            // consuming 'AdditionOperator' will consume either Plus or Minus as they are subclasses of AdditionOperator
            $.CONSUME(AdditionOperator);
            //  the index "2" in SUBRULE2 is needed to identify the unique position in the grammar during runtime
            $.SUBRULE2($.multiplicationExpression, { LABEL: 'rhs' });
        });
    });

    $.RULE('percentOfExpression', () => {
        $.CONSUME(PercentLiteral);
        $.CONSUME(OfExpression);
        $.CONSUME(NumberLiteral);
    });

    $.RULE('whatNumberOfPercentExpression', () => {
        $.CONSUME(NumberLiteral);
        $.CONSUME(IsToken);
        $.CONSUME(PercentLiteral);
        $.CONSUME(OfToken);
    });

    $.RULE('multiplicationExpression', () => {
        $.SUBRULE($.powerExpression, { LABEL: 'lhs' });

        $.MANY(() => {
            $.CONSUME(MultiplicationOperator);
            //  the index "2" in SUBRULE2 is needed to identify the unique position in the grammar during runtime
            $.SUBRULE2($.powerExpression, { LABEL: 'rhs' });
        });
    });

    $.RULE('powerExpression', () => {
        $.SUBRULE($.atomicExpression, { LABEL: 'base' });
        $.MANY(() => {
            $.CONSUME(PowerOperator);
            $.SUBRULE2($.atomicExpression, { LABEL: 'exponent' });
        });
    });

    $.RULE('atomicExpression', () =>
        $.OR([
            // parenthesisExpression has the highest precedence and thus it appears
            // in the "lowest" leaf in the expression ParseTree.
            { ALT: () => $.SUBRULE($.parenthesisExpression) },
            { ALT: () => $.SUBRULE($.unaryExpression) },
            { ALT: () => $.CONSUME(NumberLiteral) },
            { ALT: () => $.CONSUME(PercentLiteral) }
        ])
    );

    $.RULE('parenthesisExpression', () => {
        $.CONSUME(LParen);
        $.SUBRULE($.expression);
        $.CONSUME(RParen);
    });

    $.RULE('unaryExpression', () => {
        $.CONSUME(Minus);
        $.SUBRULE($.atomicExpression);
    });
};

export class MathParser extends CstParser {
    constructor() {
        super(allTokens);

        defineRules(this);

        this.performSelfAnalysis();
    }
}

export const parser = new MathParser([]);
